import React, { FC, Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { MasterLayout } from "../../_private/layout/MasterLayout";
import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../_private/assets/ts/_utils";
import { WithChildren } from "../../_private/helpers";
import { Dashboard } from "../pages/Home";
import { lazyRetry } from "../../utils/lazyRetry";
import ErrorBoundary from "../../utils/ErrorBoundary";
import { PageDataProvider } from "../../_private/layout/core";


/***********user-role management**********/
const RoleManagement = React.lazy(() => import("../pages/roleManagement/RoleManagement"));
// const UserManagement = React.lazy(() => import("../pages/userManagement/UserManagement"));
const UserRoles = React.lazy(() => import("../pages/roleManagement/UserRoles"));

/***********Wallet management**********/
const ViewWalletDetails = React.lazy(() => import("../pages/wallet/ViewDetails"));
const UpdateBalance = React.lazy(() => import("../pages/wallet/UpdatedBalance"));

/***********Client management**********/
const ClientList = React.lazy(() => import("../pages/client/ClientList"));
// const AddClient = React.lazy(() => import("../pages/client/clientAction/AddClient"));
const AddClient = React.lazy(() =>lazyRetry(() =>import("../pages/client/clientAction/AddClient")));
const EditClient = React.lazy(() => import("../pages/client/clientAction/EditClient"));
const UpdatePasswordClient = React.lazy(() => import("../pages/client/clientAction/UpdateClientPassword"));
const AssignProvider = React.lazy(() => import("../pages/client/clientAction/AssignProvider"));
const ManageClient = React.lazy(() => import("../pages/client/Account List/AccountList"));
// const AddOperatorAccount = React.lazy(() => import("../pages/client/clientAction/AddOperatorAccount"));
const AddOperatorAccount = React.lazy(() =>lazyRetry(() =>import("../pages/client/clientAction/AddOperatorAccount")));
const AssignProviderToAccount = React.lazy(() => import("../pages/client/clientAction/AssignProviderToAccount"));
const TransferBalanceToAccount = React.lazy(() => import("../pages/client/clientAction/TransferBalance"));
const AssignBetRange = React.lazy(() => import("../pages/client/clientAction/AssignBetRange"));
const ManageOperator = React.lazy(() => import("../pages/client/manageOperator/ManageOperator"));
const ClientAccountPlayerLog = React.lazy(() => import("../pages/client/playerDetails/PlayerDetail"));

/***********Provider management**********/
const Providers = React.lazy(() => import("../pages/provider/Provider"));
const ProviderViewDetails = React.lazy(() => import("../pages/provider/ProviderActions/ProviderViewDetails"));
const AddMainProvider = React.lazy(() => import("../pages/provider/AddMainProvider"));
const EditMainProvider = React.lazy(() => import("../pages/provider/ProviderActions/ProviderEditDetails"));
const ProviderAccountList = React.lazy(() => import("../pages/provider/accountList/AccountList"));
const ManageProviderAccountDetails = React.lazy(() => import("../pages/provider/manageOperator"));
const AddProviderAccount = React.lazy(() => import("../pages/provider/Action/AddProviderAccount"));

/***********Report management**********/
const GameWiseReports = React.lazy(() => import("../pages/reports/GameReports"));
const ProvidersWiseReports = React.lazy(() => import("../pages/reports/Provider"));
const GameCategoriesWiseReports = React.lazy(() => import("../pages/reports/Categories"));
const RevenueWiseReports = React.lazy(() => import("../pages/reports/Revenue"));
const TransactionWiseReports = React.lazy(() => import("../pages/reports/Transaction"));
const ProviderTransctionReports = React.lazy(() => import("../pages/reports/ProviderTransction"));

/***********Player management**********/
const Players = React.lazy(() => import("../pages/players/Players"));
const PlayerDetails = React.lazy(() => import("../pages/players/playerAction/PlayerDetails"));
const SuspiciousActivityList = React.lazy(() => import("../pages/players/SuspiciousActivityList"));

/***********Game management**********/
const GameList = React.lazy(() => import("../pages/games/GameList"));
const UpdateGameList = React.lazy(() => import("../pages/games/gameAction/GameListEditRecord"));
const GameUpload = React.lazy(() => import("../pages/games/GameUpload"));
const GameBulkUpload = React.lazy(() => lazyRetry(() => import("../pages/games/GameBulkUpload")));
const SelectTopRanking = React.lazy(() => import("../pages/games/SelectTopRanking"));
const SetTopRanking = React.lazy(() => import("../pages/games/SetTopRanking"));

/***********Category management**********/
const GameCategory = React.lazy(() => import("../pages/gameCategory/GameCategory"));
const AddGameCategory = React.lazy(() => import("../pages/gameCategory/actionsGameCategory/AddGameCategoryComponent"));
const UpdateGameCategory = React.lazy(() => import("../pages/gameCategory/actionsGameCategory/EditGameCategoryComponent"));

/***********Assign Provider**********/
const AssignProviderToClient = React.lazy(() => import("../pages/assignProviderClient/AssignProviderToClients"));

/***********Assign Game**********/
const AssignGameToClient = React.lazy(() => import("../pages/assignGamesAccount/AssignInActiveGamesAccount"));
const AssignGamesByProvider = React.lazy(() => import("../pages/assignGamesAccount/AssignGamesByProvider"));

/***********Assign All Provider Games**********/
const AllProviderGameAssign = React.lazy(() => import("../pages/assignAllGames/AllProviderGameAssign"));

/***********search client-user**********/
const SearchUserClient = React.lazy(() => import("../pages/search/SearchUserClient"));

/***********Setting**********/
const CurrencySetting = React.lazy(() => import("../pages/setting/setting"));
const BetRangeSetting = React.lazy(() => import("../pages/setting/BetRangeSetting"));
const GlobalMaintenanceMode = React.lazy(() => import("../pages/setting/GlobalMaintenanceMode"));
const GamelaunchForPlayer = React.lazy(() => import("../pages/setting/GamelaunchForPlayer"));

/***********Developers**********/
const ClientApiListing = React.lazy(() => import("../pages/ developers/ClientApiListing"));
const AddClientApi = React.lazy(() => import("../pages/ developers/AddClientApi"));
const TestCaseList = React.lazy(() => import("../pages/ developers/TestCaseList"));
const AddTestCases = React.lazy(() => import("../pages/ developers/AddTestCases"));

/***********Logs**********/
const ProviderLogs = React.lazy(() => import("../pages/reqLogs/ProviderLogs"));
const ClientLogs = React.lazy(() => import("../pages/reqLogs/ClientLogs"));
const ResponseGraph = React.lazy(() => import("../pages/reqLogs/ResponseGraph"));

/***********Evolution Skin**********/
const EvoSkins = React.lazy(() => import("../pages/evoSkins/EvoSkins"));

/***********Assign Free Spin**********/
const AssignFreeSpin = React.lazy(() => import("../pages/assignFreeSpin/AssignFreeSpin"));

const PrivateRoutes = () => {
	/* Use Params Hook for getting client id from the URl*/
	//const { clientCode } = useParams();
	return (
		<Routes>
			<Route element={<MasterLayout />}>
				<Route path='auth/*' element={<Navigate to='/home' replace />} />
				<Route path='/home'	element={<SuspensedView><Dashboard/></SuspensedView>}/>
                
                {/***********user-role management**********/}
                <Route path='user-role-management'>
                    <Route path='role-management' element={<SuspensedView><UserRoles /></SuspensedView>}/>
                    <Route path='user-role/manage-permission' element={<SuspensedView><RoleManagement /></SuspensedView>}/>
                    {/* <Route path='user-management' element={<SuspensedView><UserManagement /></SuspensedView>}/> */}
                </Route>
                
                {/***********Wallet management**********/}
                <Route path='wallet'>
                    <Route path='transaction-history' element={<SuspensedView><ViewWalletDetails /></SuspensedView>}/>
                    <Route path='update-balance' element={<SuspensedView><UpdateBalance /></SuspensedView>}/>
                </Route>
                
                {/***********Client management**********/}
                <Route path='clients'>
                    <Route index element={<SuspensedView> <ClientList /> </SuspensedView>} />
					<Route path=':clientId' element={<SuspensedView><ClientList/></SuspensedView>} />
                    {/* <Route path='add-client' element={<SuspensedView><AddClient /></SuspensedView>}/> */}
                    <Route path='add-client' element={<ErrorBoundary><SuspensedView><AddClient /></SuspensedView></ErrorBoundary>}/>
                    <Route path=':clientId/edit-client' element={<SuspensedView><EditClient /></SuspensedView>}/>
				    <Route path=':clientId/update-password' element={<SuspensedView><UpdatePasswordClient /></SuspensedView>}/>
                    <Route path=':clientId/assign-provider' element={<SuspensedView><AssignProvider /></SuspensedView>}/>
                    {/* <Route path=':clientId/add-operator-account' element={<SuspensedView><AddOperatorAccount /></SuspensedView>}/> */}
                    <Route path=':clientId/add-operator-account' element={<ErrorBoundary><SuspensedView><AddOperatorAccount /></SuspensedView></ErrorBoundary>}/>
                    <Route path=':clientId/accounts'>	
						<Route index element={<SuspensedView><ManageClient /></SuspensedView>}/>
						<Route path=':accountId/assign-provider-account' element={<SuspensedView><AssignProviderToAccount /></SuspensedView>}/>
						<Route path=':accountId/transfer-balance' element={<SuspensedView><TransferBalanceToAccount /></SuspensedView>}/>
				    	<Route path=':accountId/assign-bet-range' element={<SuspensedView><AssignBetRange /></SuspensedView>}/>
						<Route path=':accountId/manage-operator/:player' element={<SuspensedView><ManageOperator /></SuspensedView>}/>
						<Route path=':accountId/player-log' element={<SuspensedView><PlayerDetails /></SuspensedView>} />
					</Route>
                </Route>
				
                {/***********Provider management**********/}
                <Route path='provider'>
                    <Route path='all-provider-list' element={<SuspensedView><Providers /></SuspensedView>}/>
                    <Route path='view-provider-details' element={<SuspensedView><ProviderViewDetails /></SuspensedView>}/>
                    <Route path='add-provider' element={<SuspensedView><AddMainProvider /></SuspensedView>}/>
                    <Route path='edit-provider' element={<SuspensedView><EditMainProvider /></SuspensedView>}/>
                    <Route path='account'>	
                        <Route path='account-list' element={<SuspensedView><ProviderAccountList /></SuspensedView>}/>
                        <Route path='manage-provider-account' element={<SuspensedView><ManageProviderAccountDetails /></SuspensedView>}/>
				        <Route path='add-account' element={<SuspensedView><AddProviderAccount /></SuspensedView>}/>
                    </Route>
                </Route>

                {/***********Report management**********/}
                <Route path='reports'>
                    <Route path='game-wise-report' element={<SuspensedView><GameWiseReports /></SuspensedView>}/>
                    <Route path='provider-wise-report' element={<SuspensedView><ProvidersWiseReports /></SuspensedView>}/>
                    <Route path='category-wise-report' element={<SuspensedView><GameCategoriesWiseReports /></SuspensedView>}/>
                    <Route path='revenue-report' element={<SuspensedView><RevenueWiseReports /></SuspensedView>}/>
				    <Route path='wallet-transactions-report' element={<SuspensedView><TransactionWiseReports /></SuspensedView>}/>
				    <Route path='provider-transaction-report' element={<SuspensedView><ProviderTransctionReports /></SuspensedView>}/>
                </Route>         				

                {/***********Player management**********/}
                <Route path='player'>
                    <Route path='all-player-list' element={<SuspensedView><Players /></SuspensedView>}/>
                    <Route path='player-details' element={<SuspensedView><PlayerDetails /></SuspensedView>}/>
                    <Route path='suspicious-activity-list' element={<SuspensedView><SuspiciousActivityList /></SuspensedView>}/>
                </Route>

                {/***********Game management**********/}
                <Route path='game'>
                    <Route path='all-game-list' element={<SuspensedView><GameList /></SuspensedView>}/>
				    <Route path='update-game' element={<SuspensedView><UpdateGameList /></SuspensedView>}/>
                    <Route path='upload-new-games' element={<SuspensedView><GameUpload /></SuspensedView>}/>
                    <Route path='select-top-ranking' element={<SuspensedView><SelectTopRanking /></SuspensedView>}/>
                    <Route path='set-top-ranking' element={<SuspensedView><SetTopRanking /></SuspensedView>}/>
                </Route>
                
                {/***********Category management**********/}
                <Route path='categories'>
                    <Route index element={<SuspensedView><GameCategory /></SuspensedView>}/>
                    <Route path='add-new-category' element={<SuspensedView><AddGameCategory /></SuspensedView>}/>
                    <Route path='update/:categoryId' element={<SuspensedView><UpdateGameCategory /></SuspensedView>}/>
                </Route>
                
                {/***********Assign Provider**********/}
                <Route path='/assign-providers' element={<SuspensedView><AssignProviderToClient /></SuspensedView>}/>
				                
                {/***********Assign Game**********/}
                <Route path='/assign-games' element={<SuspensedView><AssignGameToClient /></SuspensedView>}/>
                <Route path='/assign-games-by-provider' element={<SuspensedView><AssignGamesByProvider /></SuspensedView>}/>

                {/***********Assign All Provider Games**********/}
                <Route path='assign-all-provider-games' element={<SuspensedView><AllProviderGameAssign/></SuspensedView>}/>

                {/***********search client-user**********/}
                <Route path='/search-client-user' element={<SuspensedView><SearchUserClient /></SuspensedView>}/>

                {/***********Setting**********/}
                <Route path='settings'>
                    <Route path='currency' element={<SuspensedView><CurrencySetting /></SuspensedView>}/>
				    <Route path='bet-range' element={<SuspensedView><BetRangeSetting /></SuspensedView>}/>
					<Route path='global-maintenance' element={<SuspensedView><GlobalMaintenanceMode /></SuspensedView>}/>
					<Route path='launch-game' element={<SuspensedView><GamelaunchForPlayer /></SuspensedView>}/>
				</Route>
                
                {/***********Developers**********/}
                <Route path='developers'>
                    <Route path='client-api-listing' element={<SuspensedView><ClientApiListing /></SuspensedView>}/>
                    <Route path='client-api/:mode/:client_api_id/:type/:status' element={<SuspensedView><AddClientApi /></SuspensedView>}/>
				    <Route path='client-api/:mode' element={<SuspensedView><AddClientApi /></SuspensedView>}/>
                    <Route path='test-case-listing' element={<SuspensedView><TestCaseList /></SuspensedView>}/>
                    <Route path='test-case/:mode/:test_case_id/:type/:status' element={<SuspensedView><AddTestCases /></SuspensedView>}/>
				    <Route path='test-case/:mode' element={<SuspensedView><AddTestCases /></SuspensedView>}/>
                </Route>

                {/***********Logs**********/}
                <Route path='logs'>
                    <Route path='provider-logs'	element={<SuspensedView><ProviderLogs /></SuspensedView>}/>
                    <Route path='client-logs' element={<SuspensedView><ClientLogs /></SuspensedView>}/>
                    <Route path='response-graph' element={<SuspensedView><ResponseGraph /></SuspensedView>}/>
                </Route>
                
                {/***********Evolution Skin**********/}
                <Route path='evo-skins' element={<SuspensedView><EvoSkins /></SuspensedView>}/>

				{/***********Assign Free Spin**********/}
				<Route path='assign-free-spins' element={<SuspensedView><AssignFreeSpin /></SuspensedView>}/>

				{/* Page Not Found */}
				<Route path='*' element={<Navigate to='/error/404' />} />
			</Route>
			<Route path='game/bulk-upload' element={<ErrorBoundary><SuspensedView><PageDataProvider><GameBulkUpload /></PageDataProvider></SuspensedView></ErrorBoundary>} />
		</Routes>
	);
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
	const baseColor = getCSSVariableValue("--bs-primary");
	TopBarProgress.config({
		barColors: {
			"0": baseColor,
		},
		barThickness: 1,
		shadowBlur: 5,
	});
	return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
